// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Controller, EffectFade } from 'swiper'
import 'swiper/swiper-bundle.css'

Swiper.use([Navigation, Pagination, Controller, EffectFade])

document.addEventListener('DOMContentLoaded', () => {
  const quoteSliders = document.querySelectorAll('.a-quote-slider')

  quoteSliders.forEach((slider) => {
    const image = slider.querySelector('.image-slider')
    const content = slider.querySelector('.content-slider')
    const next = slider.querySelector('.button-next')
    const prev = slider.querySelector('.button-prev')

    // Quote Slider needs different Arrow Navigation on Mobile
    const nextMobile = slider.querySelector('.quotes-mobile-only .button-next')
    const prevMobile = slider.querySelector('.quotes-mobile-only .button-prev')

    const pagination = slider.querySelector('.swiper-pagination')

    const imageSwiper = new Swiper(image, {
      speed: 800,
      updateOnWindowResize: true,
      navigation: {
        nextEl: nextMobile,
        prevEl: prevMobile
      },
      breakpoints: {
        0: {
          navigation: {
            nextEl: nextMobile,
            prevEl: prevMobile
          }
        },
        992: {
          navigation: {
            nextEl: next,
            prevEl: prev
          }
        }
      },
      watchOverflow: true
    })
    const contentSwiper = new Swiper(content, {
      speed: 800,
      effect: 'fade',
      pagination: {
        el: pagination,
        clickable: true
      },
      watchOverflow: true,
      controller: {
        control: imageSwiper
      },
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    })
    imageSwiper.controller.control = contentSwiper
  })
})
